export class MapplicError extends Error {
  constructor(
    message: string,
    public readonly type: 'data' | 'network' | 'config',
    public readonly userMessage: string
  ) {
    super(message);
    this.name = 'MapplicError';
  }
}